var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 12C10.125 13.0338 10.9662 13.875 12 13.875C13.0338 13.875 13.875 13.0338 13.875 12C13.875 10.9662 13.0338 10.125 12 10.125C10.9662 10.125 10.125 10.9662 10.125 12Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 18.25C10.125 19.2838 10.9662 20.125 12 20.125C13.0338 20.125 13.875 19.2838 13.875 18.25C13.875 17.2162 13.0338 16.375 12 16.375C10.9662 16.375 10.125 17.2162 10.125 18.25Z",
    fill: "#344054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 5.75C10.125 6.78375 10.9662 7.625 12 7.625C13.0338 7.625 13.875 6.78375 13.875 5.75C13.875 4.71625 13.0338 3.875 12 3.875C10.9662 3.875 10.125 4.71625 10.125 5.75Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.88bbd9cc3141d572dc4e67d12f43a707.svg";
export { ForwardRef as ReactComponent };